import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page08({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 06' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Glutes',
							value: 'Side Step',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Leg - Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes',
							value: 'Jump Squats',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Toe Touches',
						},
						{
							header: 'Sec / Minutes',
							value: '25 sec',
						},
					],
					[
						{
							header: '(A) Glutes',
							value: 'Sumo Squat',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Crunches (Slowed)',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes',
							value: 'Pulse Squats',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Scissor Kicks',
						},
						{
							header: 'Sec / Minutes',
							value: '25 sec',
						},
					],
					[
						{
							header: '(A) Glutes',
							value: 'Glute Bridge w/(LB) (optional)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
